export default __webpack_public_path__ + "static/media/linkedin.b4a7034e.svg";